export function parseUndefinedDef() {
    return {
        not: {},
    };
}
//# sourceMappingURL=undefined.mjs.map